import { Box, Grid, Paper, Typography } from '@mui/material';
import { MdPeople } from 'react-icons/md';
import { FaRedo, FaUserPlus } from 'react-icons/fa';
import { VscGraphLine } from 'react-icons/vsc';
import { ClvBarChart } from './AnalyticsCharts';
import { CustomerKpiCard } from './CustomerKpiCard';
import { analyticsColors, analyticsPanelSx } from './analyticsStyles';

interface CustomerAnalytics {
  totalCustomers: number;
  newCustomers: number;
  returningCustomers: number;
  returningCustomersPercent: number;
}

interface ClvSegment {
  segment: string;
  avg_clv: number;
  customer_count: number;
}

interface Props {
  customerAnalytics?: CustomerAnalytics;
  clvSegments?: ClvSegment[];
}

const formatRate = (value: number) => {
  const rounded = Math.round(value * 10) / 10;
  return Number.isInteger(rounded) ? `${rounded}%` : `${rounded.toFixed(1)}%`;
};

export const CustomerAnalyticsSection = ({
  customerAnalytics,
  clvSegments,
}: Props) => {
  const cards = [
    {
      label: 'Total Customers',
      value: customerAnalytics?.totalCustomers || 0,
      icon: <MdPeople />,
    },
    {
      label: 'New Customers',
      value: customerAnalytics?.newCustomers || 0,
      icon: <FaUserPlus />,
    },
    {
      label: 'Returning Customers',
      value: customerAnalytics?.returningCustomers || 0,
      icon: <FaRedo />,
    },
    {
      label: 'Returning Customer Rate',
      value: formatRate(customerAnalytics?.returningCustomersPercent || 0),
      icon: <VscGraphLine />,
    },
  ];

  return (
    <Paper elevation={0} sx={{ ...analyticsPanelSx, mt: 3 }}>
      <Box sx={{ mb: 1.5 }}>
        <Typography
          sx={{
            fontSize: '1.125rem',
            fontWeight: 600,
            color: analyticsColors.title,
            lineHeight: 1.3,
          }}
        >
          Customer Analytics
        </Typography>
      </Box>

      <Grid
        container
        spacing={1.5}
        sx={{ mb: 2 }}
        alignItems='stretch'
      >
        {cards.map((card) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            key={card.label}
            sx={{ display: 'flex' }}
          >
            <CustomerKpiCard
              label={card.label}
              value={card.value}
              icon={card.icon}
            />
          </Grid>
        ))}
      </Grid>

      <ClvBarChart
        data={clvSegments || []}
        hasData={(customerAnalytics?.totalCustomers || 0) > 0}
      />
    </Paper>
  );
};
